import { useEffect, useMemo, useState } from "react";

import { CLICKING } from "..";
import { Meters } from "./meters";
import { Success } from "./success";
import { UploadElectricityBills } from "./uploadElectricityBills";
import endPoints from "../../../../../services/apiEndPoints";
import { PublicAreaConsumption } from "./publicAreaConsumption";
import { VacantAreaConsumption } from "./vacantAreaConsumption";
import { TenantsElectricityBills } from "./tenantsElectricityBills";
import { getData, putData } from "../../../../../services";

const TENANT_AND_ELECTRICITY_STEP = 1;
export const UPLOAD_BILL_FILES_STEP = 4;
export const MAX_STEP_ELECTRICITY = 5;

export const ElectricityData = ({
  electricityStep,
  building,
  handleNext,
  clicking,
  setClicking,
  setLoading,
  onError,
  skipElectricityStep,
}) => {
  const StepComponent = [
    Meters,
    TenantsElectricityBills,
    PublicAreaConsumption,
    VacantAreaConsumption,
    UploadElectricityBills,
    Success,
  ][electricityStep];

  const apiUrl = endPoints.OB_OPERATOR_ELECTRICITY_DATA.replace("{id}", building.id);
  const [data, setData] = useState({});
  let element = document.getElementById("bop-container");

  useEffect(() => {
    if (element) {
      element.scrollTo(0, 0);
    }
  }, [electricityStep, element]);

  const componentData = useMemo(() => {
    return [
      data.meter_type,
      data.meter_type?.electricity_bill,
      data.tenant_public_area,
      data.tenant_vacant_area,
    ][electricityStep];
  }, [data, electricityStep]);

  useEffect(() => {
    if (
      electricityStep === TENANT_AND_ELECTRICITY_STEP &&
      data.meter_type?.public_meters_owner === "TENANT" &&
      data.meter_type?.unit_meters_owner === "TENANT"
    ) {
      skipElectricityStep();
    }
  }, [electricityStep]);

  useEffect(() => {
    setLoading(true);
    getData(apiUrl, setData)
      .catch(onError)
      .finally(() => setLoading(false));
  }, [building]);

  useEffect(() => {
    if (clicking === CLICKING.none) return;
    setLoading(true);
    putData(
      apiUrl,
      () => {
        if (clicking === CLICKING.next) {
          setClicking(CLICKING.none);
        }
        handleNext();
      },
      data
    )
      .catch(onError)
      .finally(() => {
        setLoading(false);
        setClicking(CLICKING.none);
      });
  }, [clicking]);

  const onDataChange = (type, key, value) => {
    if (!type) {
      setData({ ...data, [key]: value });
    } else {
      setData({ ...data, [type]: { ...data[type], [key]: value } });
    }
  };

  return (
    <StepComponent
      meterData={data.meter_type}
      data={componentData || {}}
      onDataChange={onDataChange}
      setLoading={setLoading}
      onError={onError}
      buildingId={building.id}
      uploadedBillFiles={data.uploaded_bill_files}
    />
  );
};
